"use client";

import { cn } from "@/lib/utils";
import Link from "next/link";
import { usePathname } from "next/navigation";

const NavLink = ({
	title,
	href,
	className,
	isExternal,
	onClick,
	disabled = false,
}: {
	title: string;
	href: string;
	className?: string;
	isExternal?: boolean;
	onClick?: () => void;
	disabled?: boolean;
}) => {
	const pathname = usePathname();
	const isActive = pathname === href;

	return (
		<Link
			href={href}
			onClick={onClick}
			aria-disabled={disabled}
			target={isExternal ? "_blank" : "_self"}
			className={cn(
				"z-10 rounded-md border p-1.5 text-sm hover:text-brand-primary md:rounded-none md:border-0 md:border-b-2",
				isActive ? "border-brand-primary text-brand-primary" : "border-transparent text-gray-700",
				disabled && "pointer-events-none opacity-50",
				className
			)}
		>
			{title}
		</Link>
	);
};

export default NavLink;
